<template>
  <div style="border: 1px solid #e2e8f0; border-radius: 5px;">
    <!-- Linked User Row -->
    <div class="d-flex p-3" v-if="!hasContentSharesV2Enabled">
      <b-avatar src="https://i.pravatar.cc/300" text="JD" size="2.5rem" class="mr-3" />
      <div>
        <div><strong>John Doe</strong> • <span class="text-muted">1st</span></div>
        <div><small class="text-muted">Software Engineer at Real Links • 2h</small></div>
      </div>
    </div>
    <div class="d-flex p-3 justify-content-start align-items-center" v-if="hasContentSharesV2Enabled">
      <b-avatar src="https://i.pravatar.cc/300" text="JD" size="2.5rem" class="mr-3" />
      <div><strong>John Doe</strong></div>
    </div>

    <!-- LinkedIn Share Text -->
    <div class="px-3 pb-3" v-if="!hasContentSharesV2Enabled">{{ shareText || defaults.shareText }}</div>
    <div class="px-3" v-if="hasContentSharesV2Enabled">
      <p class="m-0" style="white-space: pre-line">{{shareText || defaults.shareText}}</p>

      <!-- #0a66c2 - LinkedIn color for tags and links -->
      <strong><p style="color: #0a66c2">{{ tags }}</p></strong>
    </div>

    <!-- LinkedIn Link Preview -->
    <div style="cursor: pointer;" @click="openURL" v-if="!hasContentSharesV2Enabled">
      <div>
        <b-img v-if="!loading" :src="imageURL || defaults.imageURL" alt="Image" fluid />
        <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 200px;">
          <b-spinner type="grow" variant="primary" />
        </div>
      </div>
      <div class="flex-fill p-3">
        <div><strong>{{ title || defaults.title }}</strong></div>
        <div>{{ description || defaults.description }}</div>
        <div><a :href="url" target="_blank">{{ domain }}</a></div>
      </div>
    </div>

    <transition name="fade" v-if="hasContentSharesV2Enabled">
      <div v-if="postType === 'image'" style="cursor: pointer;" @click="openURL">
        <content-share-image
          :shareText="shareText"
          :imageURL="imageURL"
          :loading="loading"
        />
      </div>
    </transition>
    <transition name="fade" v-if="hasContentSharesV2Enabled">
     <div v-if="postType === 'link'" class="p-3">
      <content-share-link
        :title="title"
        :url="url"
        :imageURL="imageURL"
        :loading="loading"
      />
     </div>
    </transition>
    <transition name="fade" v-if="hasContentSharesV2Enabled">
     <div v-if="postType === 'document'" class="p-3">
      <pdf-preview :pdfSource="documentURL"/>
     </div>
    </transition>
    <transition name="fade" v-if="hasContentSharesV2Enabled">
      <div v-if="postType === 'video'" class="p-3">
        <div v-if="videoSrc">
          <video-player
            :options="{
              ...playerOptions,
              sources: [
                {
                  src: this.videoSrc,
                  type: 'video/mp4'
                }
              ],
            }"
          />
        </div>
        <b-img v-if="videoSrc === null" :src="videoImg" alt="Image" fluid />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapPreferences } from '@/mixins/root';
import ContentShareImage from '@/components/content-share/content-share-editor/ContentShareImage';
import ContentShareLink from '@/components/content-share/content-share-editor/ContentShareLink';
import PdfPreview from '@/components/content-share/PdfPreview.vue';
import VideoPlayer from '@/components/misc/video-player';

export default {
  props: {
    title: {
      type: String,
      default: '-',
    },
    url: {
      type: String,
      default: 'https://example-real-links.io/',
    },
    description: {
      type: String,
      default: '-',
    },
    shareText: {
      type: String,
      default: '-',
    },
    imageURL: {
      type: String,
      default: 'https://placehold.co/1200x628',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    postType: {
      type: String,
      default: 'link'
    },
    tags: {
      type: String,
      default: ''
    },
    documentURL: {
      type: String,
    },
    videoSrc: {
      type: String,
    }
  },
  components: {
    ContentShareLink,
    ContentShareImage,
    PdfPreview,
    VideoPlayer
  },
  computed: {
    ...mapPreferences([ 'featuresEnabled' ]),
    defaults() {
      return {
        title: '-',
        url: 'https://example-real-links.io/',
        description: '-',
        shareText: '-',
        imageURL: 'https://placehold.co/1200x628',
        postType: 'link',
        tags: '',
      };
    },
    domain() {
      try {
        return new URL(this.url || this.defaults.url).hostname;
      } catch (e) {
        return '-';
      }
    },
    hasContentSharesV2Enabled() {
      return (this.featuresEnabled || []).includes('content-share-v2');
    },
  },
  data() {
    return {
      playerOptions: {
        autoplay: false,
        controls: true,
      },
      videoImg: 'https://placehold.co/600x480?text=Upload+video'
    };
  },
  watch: {
    // Watch for changes in the video source and update the player
    videoSrc(newSrc) {
      this.videoSrc = newSrc;
    }
  },
  methods: {
    openURL() {
      window.open(this.url || this.defaults.url, '_blank');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/content-share/content-share-editor/SocialMediaPreview.vue